<template>
  <div class="technology-editor-container">
    <div class="sprites-content item">
      <sprite-compoents></sprite-compoents>
    </div>
    <div class="technology-stage item" id="technology-stage"></div>
    <app-header class="header-content" @export="exportConfig" @import="importConfig" @clear="clear"></app-header>

    <sprite-settings ref="spritesetting"></sprite-settings>
    <el-dialog title="导入配置" :modal="false" :visible.sync="dialogFormVisible">
      <div>
        <input type="file" id="configfile" @change="getFile" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出配置" :visible.sync="exportConfigVisible" :modal="false">
      <el-form label-position="left" label-width="80px" :model="configForm" :rules="rules" ref="form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="configForm.name" size="mini" placeholder="保存云端时填写"></el-input>
        </el-form-item>
        <el-form-item label="key" prop="key">
          <el-input :disabled="readOnly" v-model="configForm.key" size="mini"
            placeholder="保存云端时填写，用于打开页面的唯一标识"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="sn">
          <el-input v-model="configForm.sn" type="number" size="mini" placeholder="保存云端时填写，页面的顺序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportConfigVisible = false">取 消</el-button>
        <el-button @click="updateCloud">更新云端</el-button>
        <el-button @click="uploadCloud" type="success">上传云端</el-button>
        <el-button type="primary" @click="dowloadConfigFile">下载文件</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Core from "@/libs/src/core";
import spriteCompoents from "./sprite-compoents.vue";
import spriteSettings from "./srpite-setting.vue";
import AppHeader from "./header.vue";
import DownloadFile from "./utils/downloadFile";

import localforage from "localforage";

export default {
  components: { spriteCompoents, AppHeader, spriteSettings },
  data() {
    return {
      topoConfig: null,
      technologyConfig: "",
      dialogFormVisible: false,
      /** @type {TECHNOLOGYTOPO} */
      topology: null,
      exportConfigVisible: false,
      configData: "",
      readOnly: false,
      // 上传云端数据
      configForm: {
        name: "",
        key: "",
        sn: 0,
        data: "",
      },
      rules: {
        name: [{ required: true, message: "输入名称", trigger: "blur" }],
        key: [{ required: true, message: "输入key", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.topoInit();
      }, 1000);
    });
  },
  created() {
    /** @type {TECHNOLOGYTOPO} */
    this.topology = Core.getProvider("TechnologyTopo");
    this.DPC = this.$Core.getProvider("DPC");
    this.watchEditConfig();
    document.onbeforeunload = function (event) {
      event.preventDefault();
      event.returnValue = "";
      return '23424'
    }
  },

  methods: {
    getFile(evt) {
      // console.log(evt.target.files);
      const file = evt.target.files[0];
      file.text().then((res) => {
        // localforage.removeItem("topologyCache");
        let topoConfig = this.topology.deConfig(res);
        if (topoConfig) {
          this.topology.stageCanvas.open(topoConfig);
        }

        this.topology.stageCanvas.inactive();
        this.dialogFormVisible = false;
      });
    },
    async topoInit() {


      this.topology.createStage("technology-stage");
      this.editTopoConfigProps();
      this.autoUpdate();
      this.insetConfig();

    },
    // 上传配置文件到上线
    uploadCloud() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          this.topology.TopoComponents.uploadPagesCloud(this.configForm)
            .then((res) => {
              this.$message.success(res.message);
              this.exportConfigVisible = false;
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 设置编辑在线文件的本地默认属性
    async editTopoConfigProps() {
      let topologyCache = await localforage.getItem("topologyCache");

      if (topologyCache) {
        this.configForm.name = topologyCache.name;
        this.configForm.key = topologyCache.key;
        this.configForm.sn = topologyCache.sn;
      }
      return topologyCache;
    },
    async exportConfig() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.editTopoConfigProps();

      this.topology.saveConfig();
      try {
        this.configForm.data = await this.topology.enConfig();
        this.exportConfigVisible = true;
      } catch (error) {
        this.$message.error("没有选择设备");
      }
      loading.close();
    },
    // 下载文件
    dowloadConfigFile() {
      this.topology.download();
      this.exportConfigVisible = false;
    },
    async importConfig() {
      this.dialogFormVisible = true;
    },
    async insetConfig() {
      try {
        let config = await this.topology.getConfig();

        if (config) {
          this.topology.stageCanvas.open(config);
        }

        this.topology.stageCanvas.inactive();
      } catch (error) {
        console.log(error);
        // alert("没有选择设备");
      }
    },
    // 清空缓存数据
    clear() {
      this.topology.clearStage();
      localforage.removeItem("topologyCache");
      this.configForm = {
        name: "",
        key: "",
        sn: 0,
        data: "",
      };
      // localStorage.removeItem("technologyConfig");
    },
    // 执行mqtt的数据更新
    autoUpdate() {
      // 监听module的更新
      this.DPC.proc.watch("modules", (val) => {
        this.topology.update(val);
      });

      // 放置重复保存
      let stop = null;

      window.addEventListener("keydown", (e) => {

        if (e.key == "Control") {
          e.stopPropagation();
          e.preventDefault();
        }
        if (e.key == "Escape") {
          this.topology.stageCanvas.inactive();
        }
        
        if (e.ctrlKey == true && e.key == "s") {
          e.stopPropagation();
          e.preventDefault();
          if (stop) {
            this.$message.warning("正在保存，请稍等...");
            return;
          };
          stop = true;
          this.topology.saveConfig().then(() => {
            setTimeout(() => {
              stop = false;
            }, 5000)
          })
          if (this.topology.proc.data.editConfig) {
            localforage.setItem(
              "topologyCache",
              this.topology.proc.data.editConfig
            )
          }

          this.$message.success("保存成功");
        }
      });
    },
    async updateCloud() {
      let val =
        (await localforage.getItem("topologyCache")) ??
        this.topology.proc.data.editConfig;

      this.$alert("确认更新云端数据,这将覆盖云端文件？").then(async () => {
        if (!val) {
          this.$message.error("该本地文件不存在云端文件");
          return;
        }
        let data = await this.topology.enConfig();
        let res = await this.topology.TopoComponents.editPagesCloud(val.id, {
          name: this.configForm.name,
          key: this.configForm.key,
          sn: this.configForm.sn,
          data,
        }).catch((err) => {
          console.log(err);
          this.$message.error(err.message);
        });
        this.$message.success(res.message);
        this.exportConfigVisible = false;
      });
    },
    // 监听云端文件编辑
    watchEditConfig() {
      //有编辑的数据
      this.topology.proc.watch("editConfig", (val) => {
        if (!val) return;

        this.configForm.name = val.name;
        const loading = this.$loading({
          lock: true,
          text: "加载文件中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        localforage.setItem(
          "topologyCache",
          val
        )

        DownloadFile(val.url).then((text) => {
          let config = this.topology.deConfig(text);
          if (config) {
            this.topology.stageCanvas.open(config);
          }
          loading.close();
        });
      });
    },
  },
};
</script>
<style lang="scss">
.technology-editor-container {
  height: 100%;
  display: flex;
  position: relative;
  padding-top: 55px;
  box-sizing: border-box;

  .header-content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 0 15px 1px rgba($color: #000000, $alpha: 0.2);
    height: 50px;
  }

  .sprites-content {
    width: 260px;
    background-color: #eee;
    height: 100%;
    overflow-y: auto;
    position: relative;
    z-index: 2;

    &::-webkit-scrollbar {
      width: 2px;
    }
  }

  .technology-stage {
    height: 100%;
    flex: 1;
    // background-color: #cc6666;
  }
}

.el-message-box__wrapper {
  z-index: 999999999999 !important;
}
</style>